module.exports = __webpack_public_path__ + "static/media/database.3b5c5ad3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/skills/database.png
// module id = 71
// module chunks = 0